<template>
  <div class="page">
    <div class="wrapper">
      <div class="mTitle center">立吉答题用户隐私协议</div>
      <div v-for="(item, index) in infos" :key="index">
        <div class="title" v-if="item.title">{{ item.title }}</div>
        <div
          class="desc"
          v-for="(citem, cindex) in item.lists"
          :key="cindex"
          v-html="citem"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      infos: [
        {
          lists: [
            "生效日期：2022年3月31日",
            "欢迎您使用我们的产品和服务！我们非常重视您的隐私保护和个人信息保护。本《用户隐私协议》将帮助您了解以下内容："
          ]
        },
        {
          title: "一、引言",
          lists: [
            "为切实保护立吉答题用户隐私权，优化用户体验，我们根据现行法规及政策，制定本《用户隐私协议》。本协议将详细说明我们在获取、管理及保护用户个人信息方面的政策及措施。本协议适用于我们向您提供的所有服务，无论您是通过计算机设备、移动终端或微信小程序还是其他方式获得的。",
            "本《用户隐私协议》旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。我们希望您在使用立吉答题产品或服务前，请您务必仔细阅读并透彻理解本《用户隐私协议》，在确认充分理解并同意后使用相关产品或服务。如果您为未成年人，则您应在法定监护人陪同下审阅本隐私协议，经法定监护人审阅并同意后，您方可使用立吉答题并向立吉答题提供个人信息。如果您或监护人不同意本隐私协议任何内容，您应立即停止使用立吉答题产品或服务。一旦您开始使用立吉答题产品或服务，即表示您已充分理解并同意本政策。另外，在我们更新本《用户隐私协议》后，您继续使用我们的产品或服务，即意味着您同意本《用户隐私协议》(含更新版本)内容，并且同意我们按照本《用户隐私协议》收集、使用、保存和共享您的相关信息。"
          ]
        },
        {
          title: "二、我们收集哪些信息",
          lists: [
            "在使用我们提供的服务过程中，我们将收集以下必要的相关个人信息，以及部分您可以选择提供的个人信息。<br />1.登录账号信息：我们将获取您授权共享的头像、昵称等个人信息。当您通过微信小程序、腾讯会议等方式登录时，将获取并使用您授权后的个人信息，如头像、昵称等，以具体界面说明获取的个人信息范围为准。并在您同意本个人信息保护政策后将与您的本软件账号绑定，使您可以直接登录并使用我们的产品与/或服务。<br />2.使用过程中的信息：例如您在答题过程中主动填写的信息。<br />3.设备属性信息：为了提供更适配的服务，我们会收集您的设备属性信息，如操作系统版本、设备型号等软硬件特征信息。这些信息有助于我们了解您的设备环境，从而进行针对性的优化和适配。<br />4.设备连接信息：在您使用我们的产品时，我们会通过应用接口获取您的设备连接信息，如访问时间等。这些信息将帮助我们分析您的使用习惯，以便为您提供更加精准的服务。<br />5.其他信息：根据您的授权，我们可能会通过合法方式收集其他与提供服务相关的个人信息。<br />6.我们将协助发布者收集您主动填写的内容，包含发布者设定的、需要您主动填写的个人信息。例如：姓名、手机号等信息。您一旦主动填写并提交后，相关的个人信息即归于发布者控制。您应自行判断提供个人信息的相应风险，如您拒绝向发布者提供个人信息，请勿填写并提交。<br />7.请注意，我们仅提供数据的技术支持，不为其在使用我们的产品服务过程中出现的任何问题承担责任。未经其授权，我们不会超越法律法规和本政策授权范围来收集、使用、传输、处理、共享您的个人信息。您有权拒绝提供个人信息，但可能无法正常使用相应的服务、功能或者无法达到服务拟达到的效果。"
          ]
        },
        {
          title: "三、我们如何使用Cookie和同类技术",
          lists: [
            "为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含用户身份标识符以及一些字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的服务。我们不会将 Cookie 用于本《用户隐私协议》所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，但您可能因为该等修改，无法登录或使用我们的服务或功能。您可以通过更改您的浏览器设置限制立吉答题对Cookie的使用。以Chrome浏览器为例，您可以在Chrome浏览器右上方的下拉菜单的“浏览器设置”中，通过“设置-高级-清楚浏览数据”，选择清除您的Cookie。"
          ]
        },
        {
          title: "四、我们如何使用收集到的信息",
          lists: [
            "收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把您的信息用于下列用途：<br />1.提供服务及提升服务质量，例如在应用的排行榜等功能中展示您的头像和昵称。<br />2.设计新产品或服务，改善现有产品。<br />3.用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。<br />4.帮助我们更加了解您使用我们产品和服务的情况，从而针对性的回应您的个性化需求，以便为您提供服务、个性化内容和建议。<br />5.向您推荐您可能感兴趣的内容，以及提供产品和服务的广告。<br />6.评估广告和其他促销、推广活动的效果并加以改善。<br />7.经您许可的其他用途。"
          ]
        },
        {
          title: "五、我们如何共享、转让、公开披露您的个人信息",
          lists: [
            "我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。",
            "（一）共享",
            "我们会以高度的勤勉义务对待您的信息。除以下情形外，未经您同意，我们不会与除武汉从心信息科技有限公司及其关联公司外的任何第三方公司、组织和个人分享您的信息：<br />我们可能将我们按照本隐私协议收集的您的设备信息（如IMEI、MAC地址等）提供给我们的关联公司、合作伙伴或第三方服务提供方，用作下列用途：<br />",
            "（1）向您提供更好的客户服务和用户体验；<br />（2）实现我们收集、使用您的信息的目的；<br />（3）行使和履行我们在用户服务协议、本隐私协议或平台其他规则中规定的我们的权利和义务；<br />（4）理解、维护和改善我们的产品及服务。",
            "（二）转让",
            "我们不会将您的个人信息转让给除武汉从心信息科技有限公司及其关联公司外的任何公司、组织和个人，但以下情形除外：<br />1.事先获得您的明确授权或同意；<br />2.满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；<br />3.如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此用户隐私协议的约束，否则我们将要求该公司、组织重新向您征求授权同意。",
            "（三）公开披露",
            "我们仅会在以下情形下，公开披露您的个人信息：<br />1.获得您的明确同意；<br />2.基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。",
            "（四）例外情形",
            "在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：1.与国家安全、国防安全直接相关的；<br />2.与公共安全、公共卫生、重大公共利益直接相关的；<br />3.与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />5.您自行向社会公众公开的个人信息；<br />6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br />7.根据个人信息主体要求签订和履行合同所必需的；<br />8.用于维护所提供的产品或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；<br />9.法律法规规定的其他情形。<br />10.根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。"
          ]
        },
        {
          title: "六、您的权力",
          lists: [
            "按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：",
            "1.查阅、复制、更正、补充、删除：您可以在 个人中心>编辑资料 对您提供的账户信息进行操作。若您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们服务时所产生的个人信息，请通过联系客服找到我们。<br/>2.注销账号：您可以在 个人中心>编辑资料>注销账号。<br/>3.撤回同意：您可以随时通 个人中心>反馈和建议，联系客服撤回对特定信息处理的同意。<br/>4.投诉举报：如有违反本协议的行为，可通过个人中心>反馈和建议，联系客服执行操作。"
          ]
        },
        {
          title: '七、我们如何存储您的信息',
          lists: [
            '我们在中华人民共和国境内运营中收集和产生的个人信息，原则上存储在中国境内，并按照中国中华人民共和国法律法规、部门规章等规定的存储期限存储您的个人信息。'
          ]
        },
        {
          title: '八、我们如何保护您的信息',
          lists: [
            '1.我们非常重视您的个人信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于采取信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。',
            '2.尽管有上述第1款的约定，但是请您理解并明白，由于存在各种各样无法预知或现有技术无法防御的恶意手段，即便我们已经尽力采取必要的保护措施，您的信息仍有可能被泄露、毁损或灭失。如您发现您的账号、密码因任何原因已经或者将要泄露时，您应当立即跟我们联系，以便我们可以及时采取应对措施防止或减少您的相关损失。',
            '3.如果我们发生企业合并、分立等情形的，则您的信息将由届时存续的企业主体继续履行保护义务，并由我们以公告等方式通知您；如果我们的产品、服务停止运营的，则我们将及时停止继续收集您的信息，并以公告等方式通知您，届时我们将对您的信息进行删除或隐匿化处理。'
          ]
        }, {
          title: '九、未成年人保护',
          lists: [
            '我们重视未成年人的信息保护，如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许，父母或监护人明确同意或者保护未成年人所必要的情况下使用，共享，转让或披露此信息。我们将根据国家相关法律法规及本《用户隐私协议》的规定保护未成年人的个人信息。'
          ]
        },
        {
          title: '十、您的个人信息如何进行跨境转移',
          lists: [
            '原则上，我们在中国境内收集和产生的个人信息仅存储在中国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。'
          ]
        },
        {
          title: '十一、本政策如何更新',
          lists: ['我们可不定期修改本隐私协议，变更后的隐私协议将在修订生效前通过立吉答题平台公告或以其他适当方式通知您。该情况下，若您继续使用我们的服务，即表示同意修订后的协议。']
        },
        {
          title: '十二、争议管辖',
          lists: [
            '1.本隐私协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。',
            '2.有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。'
          ]
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  background: #ffffff;
  font-size: 14px;
  height: auto;
  width: auto;
  margin: 0 auto;
  max-width: 1000px;
  min-width: 320px;
  position: relative;
}
.wrapper {
  padding: 30px 30px;
}
.center {
  text-align: center;
}
.mTitle {
  font-size: rem(40);
  font-weight: bold;
  margin-bottom: rem(60);
}

.title {
  font-size: rem(30);
  margin-bottom: rem(40);
  font-weight: bold;
}
.desc {
  font-size: rem(28);
  margin-bottom: rem(40);
}

@media screen and (max-width: 500px) {
  .page {
    font-size: rem(28);
    line-height: rem(50);
    width: rem(750);
    .wrapper {
      padding: rem(60) rem(30);
    }
    .header {
      font-size: rem(46);
    }
    .mtitle {
      font-size: rem(32);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agreement/privacy.vue